

































import { $store } from "@/store";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class PdfViewerPaginator extends Vue {
  get currentPage() {
    return $store.wizard.layoutPage;
  }

  set currentPage(val) {
    if (this.scrollElem) this.scrollElem.scrollTop = 0;
    $store.wizard.layoutPage = val;
  }

  get totalPages() {
    return $store.layoutSources.layoutSource?.metadata.numberOfPages || 0;
  }

  get scrollElem() {
    return document.getElementById("pdfviewer-container");
  }

  rules = {
    minPage: (val: number) =>
      val > 0 || "El número de página debe ser mayor a cero",
    maxPage: (val: number) =>
      val <= this.totalPages || "El número de página no existe en el documento",
  };

  handleInputBlur(evt: FocusEvent) {
    const elem = evt.target as HTMLInputElement;
    const value = Number(elem.value);
    if (value != this.currentPage && value > 0 && value <= this.totalPages) {
      this.currentPage = value;
    } else {
      elem.textContent = this.currentPage.toString();
      elem.value = this.currentPage.toString();
    }
  }

  previousPage() {
    if (this.scrollElem) this.scrollElem.scrollTop = 0;
    $store.wizard.selectedInsert = null;
    $store.wizard.previousLayoutPage();
  }

  nextPage() {
    if (this.scrollElem) this.scrollElem.scrollTop = 0;
    $store.wizard.selectedInsert = null;
    $store.wizard.nextLayoutPage();
  }
}
